var toolItemToggleArr = Array(document.querySelectorAll('[data-toggle="tool-item-toggle"]'))[0];
toolItemToggleArr.forEach(toggle=>{
	console.log(toggle)
	let item = toggle.closest('.c-file-tool-list__tool-item');
	let itemToggles = item.querySelectorAll('[data-toggle="tool-item-toggle"]');
	toggle.addEventListener('click', (e)=>{
		e.preventDefault();
		console.log(item);
		console.log(toggle);
		if (item.classList.contains('open')) {
			item.classList.remove('open')
		}else{
			item.classList.add('open')
		}
		itemToggles.forEach(itemToggle=>{
			if (true) {
				console.log(itemToggle);
			}
		})
	})
});